/// <amd-module name="SuiteCommerce.GridOrder.Summary.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.GridOrder.Summary.View", ["require", "exports", "Backbone", "SuiteCommerce.GridOrder.Common.DependencyProvider", "grid_order_summary.tpl", "SuiteCommerce.GridOrder.Utils", "SuiteCommerce.GridOrder.Configuration"], function (require, exports, Backbone_1, DependencyProvider_1, summaryTemplate, Utils_1, GridOrder_Configuration_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var SummaryView = /** @class */ (function (_super) {
        __extends(SummaryView, _super);
        function SummaryView(options) {
            var _this = _super.call(this, options) || this;
            _this.template = summaryTemplate;
            _this.quantityTotal = options.quantityTotal;
            _this.subtotal = options.subtotal;
            _this.quantitiesAreValid = options.quantitiesAreValid;
            return _this;
        }
        SummaryView.prototype.updateSummary = function (quantityTotal) {
            this.quantityTotal = quantityTotal;
        };
        SummaryView.prototype.updateSubtotal = function (subtotal) {
            this.subtotal = subtotal;
        };
        SummaryView.prototype.updateQuantitiesStatus = function (quantitiesAreValid) {
            this.quantitiesAreValid = quantitiesAreValid;
        };
        SummaryView.prototype.getContext = function () {
            var showSubtotal = true;
            if (DependencyProvider_1.ProfileModel.getInstance().hidePrices()) {
                showSubtotal = false;
            }
        var total  = this.quantityTotal

        var columnMatrixCheck = this.parentView.model.get("columnMatrixOption")

            $(document).ready(function(){
                const itemCountSpan = document.querySelector('.subtotal-count');
                if(total <= 1){
                    itemCountSpan.textContent = `(${total} item)`;
                }else{
                    itemCountSpan.textContent = `(${total} items)`;
                }
                
                if(!columnMatrixCheck){
                const rowMatrixSummary = document.querySelector('.summary-value');
                const rowMatrixSummaryQty = document.querySelector('.qty');
                if(total){
                    rowMatrixSummary.innerHTML = total
                    rowMatrixSummaryQty.textContent = "Qty."
                    
                }else{
                    rowMatrixSummary.textContent = ''
                    rowMatrixSummaryQty.textContent = ""
                }
            }
            })

            return {
                showSubtotal: showSubtotal,
                addToCartIsAvailable: this.quantitiesAreValid && this.quantityTotal > 0,
                addToCartButtonLabel: GridOrder_Configuration_1.GridOrderConfiguration.addToCartButtonLabel.replace('[[items]]', String(this.quantityTotal) || ''),
                subtotal: Utils_1.Utils.formatCurrency(String(this.subtotal)),
                quantitiesAreValid: this.quantitiesAreValid,
                subtotalPriceLabel: GridOrder_Configuration_1.GridOrderConfiguration.subtotalPriceLabel,
                quantityWarningMessage: GridOrder_Configuration_1.GridOrderConfiguration.quantityWarningMessage,
            };
        };
        return SummaryView;
    }(Backbone_1.View));
    exports.SummaryView = SummaryView;
});
